import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "../common/commonDomain";
import {
  RemoveCompanyBoardFromArticlesOfAssociation,
  RemoveCompanyBoardFromArticlesOfAssociationForm,
} from "./removeCompanyBoardFromArticlesOfAssociationDomain";
import { toRemovalMode } from "../removeSignatureFromArticlesOfAssociation/removeSignatureFromArticlesOfAssociationDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: RemoveCompanyBoardFromArticlesOfAssociation,
): RemoveCompanyBoardFromArticlesOfAssociationForm {
  return new RemoveCompanyBoardFromArticlesOfAssociationForm(dispatch, context, data);
}

export function handleEvent(
  form: RemoveCompanyBoardFromArticlesOfAssociationForm,
  event: DbotEvent,
) {
  form.handleEvent(event);
}

export function applyForm(
  form: RemoveCompanyBoardFromArticlesOfAssociationForm,
): RemoveCompanyBoardFromArticlesOfAssociation {
  return {
    type: DecisionType.removeCompanyBoardFromArticlesOfAssociation,
    paragraph: form.paragraphNumber.selected,
    removalMode: toRemovalMode(form),
  };
}

export function validate(form: RemoveCompanyBoardFromArticlesOfAssociationForm): boolean {
  return form.validate();
}

export function isValid(form: RemoveCompanyBoardFromArticlesOfAssociationForm): boolean {
  return form.isValid;
}

export const removeCompanyBoardFromArticlesOfAssociationHandler: DecisionTypeHandler<
  DecisionType.removeCompanyBoardFromArticlesOfAssociation,
  RemoveCompanyBoardFromArticlesOfAssociation,
  RemoveCompanyBoardFromArticlesOfAssociationForm
> = {
  type: DecisionType.removeCompanyBoardFromArticlesOfAssociation,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
